<div class="step-wizard">
  <div *ngFor="let item of steps">
    <app-step-header [step]="item"></app-step-header>
  </div>
</div>
